import React, { FC } from 'react'
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import { PropTypes, Typography } from '@material-ui/core';
import JetFontIcon, { JET_FONTICON_ALIASES } from '../JetFontIcon/index';
import DOMPurify from 'dompurify';

export enum NoteType {
    Warning= 'warning',
    Error = 'error',
    Information = 'information',
    Default = 'default',
    SupportWarning= 'support-warning'
  }
type NoteFontSize = 'regular' | 'normal' | 'small' | 'xsmall';
interface INoteIconProps {
  name: JET_FONTICON_ALIASES,
  color: string,
  size: number
}
interface NoteProps {
    note:string;
    type: NoteType;
    translationVariables?: {[key:string]: string},
    className?:string,
    icon?: INoteIconProps,
    iconName?: JET_FONTICON_ALIASES,
    iconColor?: string;
    iconSize?: number,
    align?: PropTypes.Alignment,
    fontSize?: NoteFontSize,
    useTranslationVariables?: boolean,
    size?:number
}

const Note:FC<NoteProps> = ({note,type,translationVariables,className,icon,align = 'center', fontSize ='normal',useTranslationVariables = true,size = 12}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    //const [icon,setIcon] = useState<JET_FONTICON_ALIASES>();
/*     useEffect(() => {
      switch(type) {
        case NoteType.Warning:
          setIcon(JET_FONTICON_ALIASES.ALCOHOL)
        break;
      }
    },[type]) */
    const getFontSizeTypography = (size: NoteFontSize,text:string) => {
      switch (size) {
        case 'regular':
          return <Typography variant="body1" className='body_regular' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text,{}) }} />
        case 'normal':
        return <Typography variant="body1" className='body_small_regular' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text,{}) }} />
        case 'xsmall':
        return <Typography variant="caption" className='caption' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text,{}) }} />
        default:
        return <Typography variant="body1" className='body_small_regular' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text,{}) }}/>
      }
    }
    return (
        <div className={`${className} ${classes.note} align-${align} note-${type}`}>
        {icon?.name ? <JetFontIcon color={icon.color} iconname={icon.name} size={icon.size ? icon.size : size} /> : null }
        {getFontSizeTypography(fontSize, useTranslationVariables ? t(note,{...translationVariables}) : note)}
      </div>
    )
}

export default Note;